module.exports = __webpack_public_path__ + "img/wenjiang1.0b61d354.png";